import { Component } from '@angular/core';
import { faMagnifyingGlassChart } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-purchase-analysis',
  templateUrl: './purchase-analysis.component.html',
  styleUrl: './purchase-analysis.component.css'
})
export class PurchaseAnalysisComponent {
  faMagnifyingGlassChart = faMagnifyingGlassChart;
  state: string = 'sale';
}
